/* eslint-disable import/prefer-default-export */
export * as Global from './Global.styles';
